/**
 * @type {string} Custom classes to apply to the component for the nature of the shape.
 */
export const VTMN_SKELETON_SHAPE = {
  LINE: 'line',
  AVATAR: 'avatar',
};

export const VTMN_SKELETON_DEFAULT_WIDTH = '100%';
